import React, { Suspense } from 'react';
import { importRemote } from 'module-federation-import-remote';
import { ErrorBoundary, PageLoading } from '@dtna/dvs-core-dcp-ui-libraries';
import { getMfeUrl } from '@dtna/dvs-core-dcp-client-utils/lib/utils/mfe';
import { store, context } from '../../store';
import { mfeLazyLoadFatalErrorHandler } from '../../utils/mfe';

const LegacyApp = React.lazy(() => importRemote<any>({
  url: getMfeUrl('LEGACY'),
  scope: 'LegacyApp',
  module: 'App',
  bustRemoteEntryCache: false,
}).catch(mfeLazyLoadFatalErrorHandler));

export default function LegacyWrapper({ navbarLoaded }: { navbarLoaded: boolean }) {
  return (
    <Suspense fallback={<PageLoading navbarLoaded={navbarLoaded} />}>
      <ErrorBoundary>
        <LegacyApp store={store} context={context} />
      </ErrorBoundary>
    </Suspense>
  );
}
